import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { MeetingSchedulerStoreService } from '../../../data-providers/meeting-scheduler-store.service';
import { MeetingForAction } from '../../interface';
import { MeetingCancellationDialogComponent } from '../cancel-meeting-dialog/cancel-confirmation-dialog.component';
import { POSTHOG_ACTIONS, POSTHOG_CATEGORIES, POSTHOG_KEYS } from '../../../constants';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'meeting-scheduler-cancel-meeting-button',
  templateUrl: './cancel-meeting-button.component.html',
  styleUrls: ['./cancel-meeting-button.component.scss'],
  standalone: false,
})
export class CancelMeetingButtonComponent implements OnDestroy {
  @Input() meeting: MeetingForAction;
  @Input() isMatItem: boolean;
  @Input() displayText: string;
  @Output() meetingCancelled: EventEmitter<void> = new EventEmitter();

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly dialog: MatDialog,
    private readonly meetingSchedulerStoreService: MeetingSchedulerStoreService,
    private readonly alertService: SnackbarService,
    private readonly analyticsService: ProductAnalyticsService,
  ) {}

  async openCancelDialog(meeting: MeetingForAction): Promise<void> {
    const dialogRef = this.dialog.open(MeetingCancellationDialogComponent, {
      width: '600px',
      data: meeting,
    });

    const cancelledMeeting = await dialogRef.afterClosed().pipe(first()).toPromise();
    if (!cancelledMeeting) {
      return;
    }

    try {
      await this.meetingSchedulerStoreService.cancelMeeting({
        meetingId: cancelledMeeting.meetingId,
        cancellationReason: cancelledMeeting.cancellationReason,
        isSessionEventType: meeting.isSessionEventType,
      });
      this.analyticsService.trackEvent(POSTHOG_KEYS.MEETING_CANCELLED, POSTHOG_CATEGORIES.USER, POSTHOG_ACTIONS.CLICK);
      this.alertService.openSuccessSnack('MEETING_SCHEDULER.MEETING_ACTIONS.ALERTS.CANCELLED_MEETING_SUCCESS');
      this.meetingCancelled.emit();
    } catch (err) {
      this.alertService.openErrorSnack('MEETING_SCHEDULER.MEETING_ACTIONS.ALERTS.CANCELLED_MEETING_ERROR');
      console.error(err);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
